

export class GeneratePdf implements IGeneratePdf {
    htmldata!: string | undefined;

    constructor(data?: IGeneratePdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.htmldata = _data["htmldata"];
        }
    }

    static fromJS(data: any): GeneratePdf {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePdf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["htmldata"] = this.htmldata;
        return data; 
    }
}

export interface IGeneratePdf {
    htmldata: string | undefined;
}

